import { Colors } from '../Colors';
import { remInPx } from '../Utils';

export default {
    defaultProps: {
        color: Colors.primaryText,
        withArrow: true,
        arrowSize: remInPx(.5),
    },
    styles: (_, { variant }) => {
        return {};
    },
};
